export const globalColors = [
    'darkPurple',
    'midPurple',
    'purple',
    'indigo',
    'white',
    'green',
    'red',
    'pink',
    'orange',
    'teal',
    'yellow',
    'grey1',
    'grey2',
    'grey3',
    'grey4',
    'grey5',
    'grey6',
    'grey7',
    'black',
    'purpleShade20',
    'purpleShade10',
    'purpleTint10',
    'purpleTint20',
    'purpleTint30',
    'purpleTint40',
    'purpleTint50',
    'purpleTint60',
    'purpleTint70',
    'purpleTint80',
    'purpleTint90',
    'darkPurpleShade20',
    'darkPurpleShade10',
    'darkPurpleTint10',
    'darkPurpleTint20',
    'darkPurpleTint30',
    'darkPurpleTint40',
    'darkPurpleTint50',
    'darkPurpleTint60',
    'darkPurpleTint70',
    'darkPurpleTint80',
    'darkPurpleTint90',
    'indigoShade20',
    'indigoShade10',
    'indigoTint10',
    'indigoTint20',
    'indigoTint30',
    'indigoTint40',
    'indigoTint50',
    'indigoTint60',
    'indigoTint70',
    'indigoTint80',
    'indigoTint90',
    'redShade20',
    'redShade10',
    'redTint10',
    'redTint20',
    'redTint30',
    'redTint40',
    'redTint50',
    'redTint60',
    'redTint70',
    'redTint80',
    'redTint90',
    'greenShade20',
    'greenShade10',
    'greenTint10',
    'greenTint20',
    'greenTint30',
    'greenTint40',
    'greenTint50',
    'greenTint60',
    'greenTint70',
    'greenTint80',
    'greenTint90',
    'tealShade20',
    'tealShade10',
    'tealTint10',
    'tealTint20',
    'tealTint30',
    'tealTint40',
    'tealTint50',
    'tealTint60',
    'tealTint70',
    'tealTint80',
    'tealTint90',
    'pinkShade20',
    'pinkShade10',
    'pinkTint10',
    'pinkTint20',
    'pinkTint30',
    'pinkTint40',
    'pinkTint50',
    'pinkTint60',
    'pinkTint70',
    'pinkTint80',
    'pinkTint90',
    'yellowTint40',
    'yellowTint30',
    'yellowTint20',
    'yellowTint10',
    'yellowShade10',
    'yellowShade20',
    'orangeTint20',
    'orangeTint10',
    'orangeShade10',
    'orangeShade20',
    'orangeShade30',
    'transparent',
] as const;

export type TGlobalColors = typeof globalColors[number];
